// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type SlackListsItemsInfoResponse = SlackAPIResponse & {
  error?: string;
  list?: List;
  needed?: string;
  ok: boolean;
  provided?: string;
  record?: Record;
  response_metadata?: ResponseMetadata;
  subtasks?: Record[];
  warning?: string;
};

export interface List {
  access?: string;
  created?: number;
  display_as_bot?: boolean;
  editable?: boolean;
  external_type?: string;
  file_access?: string;
  filetype?: string;
  has_rich_preview?: boolean;
  id?: string;
  is_ai_suggested?: boolean;
  is_external?: boolean;
  is_public?: boolean;
  is_restricted_sharing_enabled?: boolean;
  is_starred?: boolean;
  last_editor?: string;
  list_csv_download_url?: string;
  list_limits?: ListLimits;
  list_metadata?: ListMetadata;
  mimetype?: string;
  mode?: string;
  name?: string;
  org_or_workspace_access?: string;
  permalink?: string;
  permalink_public?: string;
  pretty_type?: string;
  public_url_shared?: boolean;
  size?: number;
  skipped_shares?: boolean;
  teams_shared_with?: string[];
  timestamp?: number;
  title?: string;
  updated?: number;
  url_private?: string;
  url_private_download?: string;
  user?: string;
  user_team?: string;
  username?: string;
}

export interface ListLimits {
  archived_row_count?: number;
  column_count?: number;
  column_count_limit?: number;
  max_attachments_per_cell?: number;
  over_column_maximum?: boolean;
  over_row_maximum?: boolean;
  over_view_maximum?: boolean;
  row_count?: number;
  row_count_limit?: number;
  view_count?: number;
  view_count_limit?: number;
}

export interface ListMetadata {
  creation_source?: CreationSource;
  default_view?: string;
  description?: string;
  description_blocks?: DescriptionBlock[];
  icon?: string;
  integrations?: string[];
  is_trial?: boolean;
  schema?: Schema[];
  subtask_schema?: SubtaskSchema[];
  todo_mode?: boolean;
  views?: View[];
}

export interface CreationSource {
  reference_id?: string;
  type?: string;
}

export interface DescriptionBlock {
  block_id?: string;
  elements?: DescriptionBlockElement[];
  type?: string;
}

export interface DescriptionBlockElement {
  elements?: ElementElementClass[];
  type?: string;
}

export interface ElementElementClass {
  text?: string;
  type?: string;
}

export interface Schema {
  id?: string;
  is_primary_column?: boolean;
  key?: string;
  name?: string;
  options?: SchemaOptions;
  type?: string;
}

export interface SchemaOptions {
  choices?: Choice[];
  format?: string;
  show_member_name?: boolean;
}

export interface Choice {
  color?: string;
  label?: string;
  value?: string;
}

export interface SubtaskSchema {
  id?: string;
  is_primary_column?: boolean;
  key?: string;
  name?: string;
  options?: SubtaskSchemaOptions;
  type?: string;
}

export interface SubtaskSchemaOptions {
  format?: string;
  show_member_name?: boolean;
}

export interface View {
  columns?: Column[];
  created_by?: string;
  date_created?: number;
  default_view_key?: string;
  id?: string;
  is_all_items_view?: boolean;
  is_locked?: boolean;
  name?: string;
  position?: string;
  show_completed_items?: boolean;
  stick_column_left?: boolean;
  type?: string;
}

export interface Column {
  id?: string;
  key?: string;
  position?: string;
  visible?: boolean;
}

export interface Record {
  created_by?: string;
  date_created?: number;
  fields?: Field[];
  id?: string;
  is_subscribed?: boolean;
  list_id?: string;
  updated_by?: string;
  updated_timestamp?: string;
}

export interface Field {
  checkbox?: boolean;
  column_id?: string;
  key?: string;
  value?: boolean;
}

export interface ResponseMetadata {
  messages?: string[];
}
